import React from 'react';
import { useSeo } from './site/ui';
import { Hero, ProofStrip, SegmentTiles, Pains, HowItFits, Showcases, useProof } from './site/HomeSections';
import { DriveIqPanel, Journey, Team, FoundingOffer, PricingTeaser, Faq, Closing } from './site/HomeSections2';
import { SwitchStrip } from './site/SwitchStrip';
import { StoriesSection } from './site/Stories';
import { TrustSection } from './site/TrustSection';

export default function DrivelineHome() {
  useSeo({
    title: 'Driveline · Workshop software for detailing, body shops and service | India',
    description: 'Job cards, GST invoices, inspections, parts, eWarranty and payroll in one place. Built inside a working workshop in Bangalore. Book a demo.',
  });
  const proof = useProof();
  return (
    <div data-testid="driveline-home">
      <Hero />
      <SwitchStrip />
      <ProofStrip proof={proof} />
      <SegmentTiles />
      <Pains />
      <HowItFits />
      <Showcases />
      <DriveIqPanel />
      <Journey />
      <Team />
      <StoriesSection />
      <TrustSection />
      <FoundingOffer proof={proof} />
      <PricingTeaser />
      <Faq />
      <div id="enquiry"><Closing /></div>
    </div>
  );
}
